import normalizeText from '@/lib/normalizeText.js';

const toOperationFamily = (operationType) => {
  const normalized = normalizeText(operationType).toLowerCase();

  if (normalized === 'create') {
    return 'create';
  }

  if (normalized === 'delete') {
    return 'delete';
  }

  if (normalized === 'update' || normalized === 'upsert' || normalized === 'write') {
    return 'update';
  }

  return 'update';
};

const toOperationVerb = (operationType) => {
  const family = toOperationFamily(operationType);

  if (family === 'create') {
    return 'Created';
  }

  if (family === 'delete') {
    return 'Deleted';
  }

  return 'Updated';
};

const toOperationTagText = ({ family, count }) => {
  const safeCount = Number.isFinite(Number(count)) ? Math.max(0, Math.floor(Number(count))) : 0;

  if (safeCount < 1) {
    return '';
  }

  if (family === 'create') {
    return `${safeCount} created`;
  }

  if (family === 'delete') {
    return `${safeCount} deleted`;
  }

  return `${safeCount} updated`;
};

const buildOperationSearchableText = (item) => {
  const searchKeyText = (Array.isArray(item?.searchKeys) ? item.searchKeys : [])
    .map((entry) => {
      return `${normalizeText(entry?.key)} ${normalizeText(entry?.value)}`.trim();
    })
    .filter(Boolean)
    .join(' ');

  return [item?.summary, item?.entityDisplay, item?.entityId, item?.entityTypeLabel, item?.appName, item?.appSlug, item?.actionName, item?.actionId, item?.operationId, item?.userDisplay, item?.userId, searchKeyText].map((value) => normalizeText(value).toLowerCase()).join(' ');
};

const getVisibleOperationFilterOptions = ({ rows = [], options = [] } = {}) => {
  const visibleFamilies = new Set((Array.isArray(rows) ? rows : []).map((item) => toOperationFamily(item?.operationType)).filter(Boolean));

  return (Array.isArray(options) ? options : []).filter((option) => {
    if (option?.id === 'all') {
      return true;
    }

    return visibleFamilies.has(option?.id);
  });
};

export { toOperationFamily, toOperationVerb, toOperationTagText, buildOperationSearchableText, getVisibleOperationFilterOptions };
